<app-generic-side-modal-container [sideNavTitleText]="'Daily Schedule' | translate">
  
  <div mainPageContent class="flex flex-row justify-start page-height w-full lg:p-[5rem] px-[1rem] pt-[1rem] sm:mb-0 mb-[6rem]">
    
    <div class="grid grid-cols-1 xl:grid-cols-2 gap-[2rem] w-full h-max overflow-clip p-5 pb-[5rem]">
  
      <a href="./dashboard/term" class="sm:w-full flex flex-row justify-center align-middle items-center">
        <div class="mat-elevation-z8 mid-box homeMenuItemBg bg-[#2C99B1] w-full h-[13vh] p-3 xl:p-8 flex flex-row justify-start">
          <div class="bigButton">
            <div class="iconBackground bg-black/30 backdrop-blur-sm">
              <i class="text-white text-[2rem] sm:text-[1.8rem] xl:text-[2rem] fa-regular fa-calendar-days"></i>
            </div>
            <div style="text-align: left; margin-left: 3vh;">
              <div class="text-[1rem] xs:text-[1.3rem] sm:text-[1.5rem] 2xl:text-[1.8rem] text-white font-semibold">{{"Term schedule" | translate }}</div>
              <div class="text-[0.85rem] xs:text-[1.25rem] md:text-[1.1rem] 2xl:text-[1.4rem] text-white">{{"Term schedule overview" | translate }}</div>
            </div>
          </div>
        </div>
      </a>

      <a href="./dashboard/memberships" class="sm:w-full flex flex-row justify-center align-middle items-center">
        <div class="mat-elevation-z8 mid-box homeMenuItemBg bg-[#B98D78] w-full h-[13vh] p-3 xl:p-8 flex flex-row justify-start">
          <div class="bigButton">
            <div class="iconBackground bg-black/30 backdrop-blur-sm">
              <i class="text-white text-[2rem] sm:text-[1.8rem] xl:text-[2rem] fa-regular fa-id-card"></i>
            </div>
            <div style="text-align: left; margin-left: 3vh;">
              <div class="text-[1rem] xs:text-[1.3rem] sm:text-[1.5rem] 2xl:text-[1.8rem] text-white font-semibold">{{"Membership fees" | translate }}</div>
              <div class="text-[0.85rem] xs:text-[1.25rem] sm:text-[1.1rem] 2xl:text-[1.4rem] text-white">{{"reviewAndManagementOfMembership" | translate }}</div>
            </div>
          </div>
        </div>
      </a>

      <a href="./dashboard/service" class="sm:w-full flex flex-row justify-center align-middle items-center">
        <div class="mat-elevation-z8 mid-box homeMenuItemBg bg-[#D76969] w-full h-[13vh] p-3 xl:p-8 flex flex-row justify-start">
          <div class="bigButton">
            <div class="iconBackground bg-black/30 backdrop-blur-sm">
              <i style="font-size: 3vh; color: #fff;" class="fa-duotone fa-chart-simple"></i>
            </div>
            <div style="text-align: left; margin-left: 3vh;">
              <div class="text-[1rem] xs:text-[1.3rem] sm:text-[1.5rem] 2xl:text-[1.8rem] text-white font-semibold">{{"services" | translate }}</div>
              <div class="text-[0.85rem] xs:text-[1.25rem] sm:text-[1.1rem] 2xl:text-[1.4rem] text-white">{{"Overview and management of services" | translate }}</div>
            </div>
          </div>
        </div>
      </a>

      <a href="./dashboard/users" class="sm:w-full flex flex-row justify-center align-middle items-center">
        <div class="mat-elevation-z8 mid-box homeMenuItemBg bg-[#AAA86F] w-full h-[13vh] p-3 xl:p-8 flex flex-row justify-start">
          <div class="bigButton">
            <div class="iconBackground bg-black/30 backdrop-blur-sm">
              <i class="text-white text-[2rem] sm:text-[1.8rem] xl:text-[2rem] fa-regular fa-users "></i>
            </div>
            <div style="text-align: left; margin-left: 3vh;">
              <div class="text-[1rem] xs:text-[1.3rem] md:text-[1.5rem] 2xl:text-[1.8rem] text-white font-semibold">{{"Users" | translate }}</div>
              <div class="text-[0.85rem] xs:text-[1.25rem] md:text-[1.1rem] 2xl:text-[1.4rem] text-white">{{"User overview and management" | translate }}</div>
            </div>
          </div>
        </div>
      </a>

      <a href="./dashboard/shift" class="sm:w-full flex flex-row justify-center align-middle items-center">
        <div class="mat-elevation-z8 mid-box homeMenuItemBg bg-[#EE8D56] w-full h-[13vh] p-3 xl:p-8 flex flex-row justify-start">
          <div class="bigButton">
            <div class="iconBackground bg-black/30 backdrop-blur-sm">
              <i class="text-white text-[2rem] sm:text-[1.8rem] xl:text-[2rem] fa-regular fa-calendar-week"></i>
            </div>
            <div style="text-align: left; margin-left: 3vh;">
              <div class="text-[1rem] xs:text-[1.3rem] sm:text-[1.5rem] 2xl:text-[1.8rem] text-white font-semibold">{{"Shift schedule" | translate }}</div>
              <div class="text-[0.85rem] xs:text-[1.25rem] sm:text-[1.1rem] 2xl:text-[1.4rem] text-white">{{"Review and management of" | translate }} <br>{{"shift schedule" | translate }}</div>
            </div>
          </div>
        </div>
      </a>

      <a href="./dashboard/configuration" class="sm:w-full flex flex-row justify-center align-middle items-center">
        <div class="mat-elevation-z8 mid-box homeMenuItemBg bg-[#927CAE] w-full h-[13vh] p-3 xl:p-8 flex flex-row justify-start">
          <div class="bigButton">
            <div class="iconBackground bg-black/30 backdrop-blur-sm">
              <i class="text-white text-[2rem] sm:text-[1.8rem] xl:text-[2rem] fa-regular fa-gear"></i>
            </div>
            <div style="text-align: left; margin-left: 3vh;">
              <div class="text-[1rem] xs:text-[1.3rem] sm:text-[1.5rem] 2xl:text-[1.8rem] text-white font-semibold">{{"Global configuration" | translate }}</div>
              <div class="text-[0.85rem] xs:text-[1.25rem] sm:text-[1.1rem] 2xl:text-[1.4rem] text-white">{{"Review and management of global configuration" | translate }}</div>
            </div>
          </div>
        </div>
      </a>

      <a href="https://cms.vacuactivskopje.mk/admin/content-manager/collection-types/api::device.device?page=1&pageSize=10&sort=DeviceName:ASC" target="_blank" class="sm:w-full flex flex-row justify-center align-middle items-center">
        <div class="mat-elevation-z8 mid-box homeMenuItemBg bg-[#6e6dce] w-full h-[13vh] p-3 xl:p-8 flex flex-row justify-start">
          <div class="bigButton">
            <div class="iconBackground bg-black/30 backdrop-blur-sm">
              <i class="text-white text-[2rem] sm:text-[1.8rem] xl:text-[2rem] fa-regular fa-file-lines"></i>
            </div>
            <div style="text-align: left; margin-left: 3vh;">
              <div class="text-[1rem] xs:text-[1.3rem] sm:text-[1.5rem] 2xl:text-[1.8rem] text-white font-semibold">{{"Strapi configuration" | translate }}</div>
              <div class="text-[0.85rem] xs:text-[1.25rem] sm:text-[1.1rem] 2xl:text-[1.4rem] text-white">{{"Strapi configuration description" | translate }}</div>
            </div>
          </div>
        </div>
      </a>
  
    </div>

  </div>

  <div sideNavContent class="w-full min-w-[35vw] xl:min-w-0">
    <div class="flex flex-col gap-[2rem] justify-center align-middle items-center 
    overflow-y-auto overflow-x-hidden w-full px-[1rem] pt-[1.5rem] pb-[2rem] mt-[-1.5rem]" *ngIf="todayTermData!.length !== 0">

      <div *ngFor="let term of todayTermData" class="w-full">

        <div class="mat-elevation-z8 mid-box w-full" style="padding: 2vh; height: max-content">
        
          <div class="daySheduling w-full">
            <div style="display: flex; justify-content: space-between; width: 100%">
              <span style="font-size: 1.6rem; font-weight: bold; display: block; margin-bottom: 1vh;">{{term.fromDate | date:"HH:mm"}} - {{term.toDate | date:"HH:mm"}}</span>
              <div>
                <span class="timeStyle" style="font-size: 1.5rem;">{{ calculateTotalMinutesDifference(term) }} {{"minutes" | translate }}</span>
              </div>
            </div>
        
            <div class="w-full">
              <div style="display: grid;">
                <span style="font-size: 1.4rem; font-weight: bold">{{term.serviceName}}</span>
                <span style="font-size: 1.4rem;">{{term.name}} {{term.surname}}</span>
              </div>
        
            </div>

            <div style="margin-top: 2vh;" class="w-full">
              <mat-divider style="border-top-color: #000; margin-bottom: 1rem;"></mat-divider>
              <span style="font-size: 1.3rem; display: flex; align-items: center;" class="w-full">
                <svg style="margin-right: 1vh;"
                  xmlns="http://www.w3.org/2000/svg" height="17" width="17" viewBox="0 0 512 512">
                  <path
                    d="M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z" />
                </svg> {{"Employee" | translate}}: {{term.employeeName}} {{term.employeeSurname}}
              </span>
            </div>

          </div>
        
        </div>

      </div>

    </div>

    <div class="flex flex-col gap-[2rem] justify-center align-middle items-center
    overflow-y-auto overflow-x-hidden w-full pt-[1.5rem] pb-[2rem] mt-[-1.5rem]" *ngIf="todayTermData?.length === 0">
    <div class="w-full flex flex-row justify-center align-middle text-center">
        <p class="text-[1.35rem] md:text-[1.5rem] text-black mt-[1rem]"> {{"No daily schedule currently found" | translate}} </p>
    </div>

    </div>
  </div>

</app-generic-side-modal-container>

